import './i18n'; // i18n must be initialized before React renders
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { App } from './App';
import { Toaster } from '@/components/ui/Toaster';
import { ConfirmDialogHost } from '@/components/ui/ConfirmDialog';
import './index.css';

// Auth → axios bridging lives in lib/api.ts: the request interceptor reads
// useAuthStore.getState().token on every request, and setToken() writes into
// the store, so no explicit bridge is needed here.

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30 * 1000,
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('Missing #root element in index.html');

createRoot(rootEl).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
        {/* Global modal + toast hosts. Mounted once at the root so any
            code can fire `confirmDialog(...)` or `toast.success(...)`
            without threading a context through component trees. */}
        <ConfirmDialogHost />
        <Toaster />
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
);
